import Component from '../core/Component';

export default class Chat extends Component {

    constructor(element) {
        super(element);
    }

    prepare() {
        this.element.addEventListener('click', event => {
            event.stopPropagation();
        })

        this.focus()
    }

    focus() {
        this.ref.input.focus();
    }

    destroy() {
        //
    }
}


// WEBPACK FOOTER //
// ./components/Chat.js